module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-11-50-055_com.pinkcoffee.sexbattle.a4fd53ca.jpg";